import React from "react";
import "../assets/css/TenantSourceField.css";

export const TENANT_SOURCES = [
  "Website",
  "Google",
  "Facebook",
  "Instagram",
  "LinkedIn",
  "WhatsApp",
  "Walk-in",
  "Cold Call",
  "Email Campaign",
  "Reference",
  "Other",
];

const REFERENCE = "Reference";

/**
 * Stored as one string: "Reference: <name>" for references, otherwise the option itself.
 * Older free-text values that are not a known option (e.g. "Ravi Aluguri, Shilpa") are treated as reference names.
 */
export function parseSource(value) {
  const raw = String(value || "").replace(/^\s+/, "");
  const match = raw.match(/^reference\b\s*[:-]?\s*(.*)$/i);
  if (match) return { option: REFERENCE, name: match[1] };
  const trimmed = raw.trim();
  if (!trimmed) return { option: "", name: "" };
  const known = TENANT_SOURCES.find((s) => s.toLowerCase() === trimmed.toLowerCase());
  return known ? { option: known, name: "" } : { option: REFERENCE, name: trimmed };
}

/** Keeps trailing spaces while typing; the API trims the stored value. */
export function composeSource(option, name) {
  if (option !== REFERENCE) return option;
  const text = String(name || "").replace(/^\s+/, "");
  return text ? `${REFERENCE}: ${text}` : REFERENCE;
}

/** Source dropdown; choosing Reference adds a "Reference Name" field in the next grid cell. */
function TenantSourceField({ value, onChange, controlClassName = "" }) {
  const { option, name } = parseSource(value);

  return (
    <>
      <div className="form-group">
        <label>Source</label>
        <select
          name="source"
          className={controlClassName}
          value={option}
          onChange={(e) => onChange(composeSource(e.target.value, e.target.value === REFERENCE ? name : ""))}
        >
          <option value="">Select source</option>
          {TENANT_SOURCES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      {option === REFERENCE ? (
        <div className="form-group">
          <label>Reference Name</label>
          <input
            type="text"
            name="sourceReferenceName"
            className={controlClassName}
            value={name}
            onChange={(e) => onChange(composeSource(REFERENCE, e.target.value))}
            placeholder="Who referred this client"
            autoComplete="off"
          />
        </div>
      ) : null}
    </>
  );
}

export default TenantSourceField;
